import moment from 'moment';
import React, { createContext, ReactNode, useState, useContext } from 'react';
import { useAuthContext } from '../../../stores/AuthContext';

import { Collaborator } from '../../../types/Filters';

type MovimentContextProps = {
  collaborators: Collaborator[];
  collaboratorsState: string;
  companySelected: number;
  professionSelected: number;
  collaboratorSelected: number;
  initialDate: any;
  finalDate: any;
  setCollaborators: (collaborators: Collaborator[]) => void;
  setCollaboratorsState: (value: string) => void;
  setCompanySelected: (companie: number) => void;
  setProfessionSelected: (profession: number) => void;
  setCollaboratorSelected: (collaborator: number) => void;
  updatePeriod: (initial: any, final: any) => void;
};

type Props = {
  children: ReactNode;
};

const MovimentContext = createContext<MovimentContextProps>({} as MovimentContextProps);

export function MovimentContextProvider(props: Props) {
  const { children } = props;

  const {authData} = useAuthContext();
  const [collaborators, setCollaborators] = useState<Collaborator[]>([]);
  const [collaboratorsState, setCollaboratorsState] = useState<string>('');
  const [initialDate, setInitialDate] = useState<any>(moment());
  const [finalDate, setFinalDate] = useState<any>(moment());
  const [collaboratorSelected, setCollaboratorSelected] = useState<number>(0);
  
  const professionId = (authData && authData.grpCompanies == '7') ? 66 : 0; //Maquinario Bayer

  const companyId = (authData && authData.grpCompanies != 'a' && (!authData.grpCompanies.includes(","))) ?
    authData.companyId:0;
    
  const [professionSelected, setProfessionSelected] = useState<number>(professionId);
  const [companySelected, setCompanySelected] = useState<number>(companyId);


  const updatePeriod = (initial: any, final: any) => {
    setInitialDate(initial);
    setFinalDate(final);
  };

  const value = {
    collaborators,
    collaboratorsState,
    collaboratorSelected,
    companySelected,
    professionSelected,
    initialDate,
    finalDate,
    setCollaborators,
    setCollaboratorsState,
    setCollaboratorSelected,
    setCompanySelected,
    setProfessionSelected,
    updatePeriod,
  };
  return <MovimentContext.Provider value={value}>{children}</MovimentContext.Provider>;
}

export function useMovimentContext() {
  const context = useContext(MovimentContext);

  if (typeof context === 'undefined') {
    throw new Error('MovimentContext must be used within an MovimentContext');
  }

  return context;
}
